export class CatalogueHistoryDetailControllerName {

  public static $inject = ['$stateParams'];
  public catalogueId: string;
  public catalogueVersion: string;
  public history: any;

  constructor(private $stateParams) {
    this.activate();
  }

  public buildDetails = (history: any) => {
    let details;
    const historyValue = this.parseHistoryValue(history.value);

    switch (history.action) {
      case 'ADD':
        details = history.type + ' ' + historyValue.name + ' added';
        break;
      case 'REPLACE':
        details = history.type + ' ' + history.field + ' replaced';
        break;
      case 'REMOVE':
        details = history.type + ' ' + historyValue.name + ' removed';
        break;
      default:
        details = '';
    }
    return details;
  }

  public parseHistoryValue = (value: any) => angular.fromJson(value);

  private activate() {
    this.catalogueId = this.$stateParams.catalogueId;
    this.catalogueVersion = this.$stateParams.catalogueVersion;
    this.history = this.$stateParams.historyItem;
  }
}